import { render } from "./DataTableRow.vue?vue&type=template&id=a0cda72a"
import script from "./DataTableRow.vue?vue&type=script&lang=js"
export * from "./DataTableRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__